// insurance.model.js
import { insuranceSubRoutes } from './routes';

export default {
	categories: [
		{ value: 'individual', label: 'Individual' },
		{ value: 'business', label: 'Business' },
	],
	subRoutes: {
		insurance: insuranceSubRoutes,
	},
};
